import script from "./VipQueueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VipQueueCard.vue?vue&type=script&setup=true&lang=js"

import "./VipQueueCard.vue?vue&type=style&index=0&id=df99bcaa&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df99bcaa"]])

export default __exports__